import { Button, Container } from '@cleartrip/ct-design-components'
import React, { ReactNode } from 'react'

export interface ButtonWithDisabledClickProps extends React.ComponentProps<typeof Button> {
  /** Called when the user clicks while the button is disabled */
  onDisabledClick?: (event: React.MouseEvent<HTMLDivElement>) => void
  /** Button content (children) */
  children?: ReactNode
}

/**
 * Wraps ct-design Button in a Container so that when the button is disabled,
 * clicks still hit the wrapper and onDisabledClick can run (e.g. show tooltip/toast).
 */
const ButtonWithDisabledClick: React.FC<ButtonWithDisabledClickProps> = ({
  onDisabledClick,
  children,
  ...buttonProps
}) => {
  const handleWrapperClick = (event: React.MouseEvent<HTMLDivElement>) => {
    if (buttonProps.disabled && onDisabledClick) {
      onDisabledClick(event)
    }
  }

  return (
    <Container onClick={handleWrapperClick}>
      <Button {...buttonProps}>{children}</Button>
    </Container>
  )
}

export default ButtonWithDisabledClick
